import { ReleaseNote } from "interfaces/releaseNote";

export const releaseNotes: ReleaseNote[] = [
    {
        date: new Date(2025, 3, 2),
        title: "Lançamento do Sistema",
        description: "Lançamento do Sistema",
        features: [
            {
                description: "Nova Feature"
            }
        ],
        improvements: [
            {
                description: "Nova melhoria"
            }
        ],
        fixes: [
            {
                description: "Correção de bugs"
            }
        ]
    },
    {
        date: new Date(2025, 3, 2),
        title: "Lançamento do Sistema",
        description: "Lançamento do Sistema",
        features: [
            {
                description: "Nova Feature"
            }
        ],
        improvements: [
            {
                description: "Nova melhoria"
            }
        ],
        fixes: [
            {
                description: "Correção de bugs"
            }
        ]
    },
]